<template>
    <div>
        <div class="content">
            <i class="iconTick iconfont icon"></i>提交成功，请等待审核
        </div>
        <div style="text-align:center;margin-top:30px;">
            <el-button type="primary" @click="withdraw">撤回审核</el-button>
        </div>
    </div>
</template>

<script>
import { UserCenterService } from '../../../service/userCenter.service'
export default {
    methods: {
        async withdraw() {
            await UserCenterService.userWithdraw()
            this.$emit('withdrawSuccess',1)
        }
    }    
}

</script>
<style lang="scss" scoped>
    .content{
        width: 870px;
        height: 30px;
        line-height: 30px;
        padding: 8px 0;
        background: #ddedf6;
        border: 0;
        font-size: 18px;
        font-weight: 700;
        .icon{
            font-size: 28px;
            margin: 0 10px;
            color: #2292d2;
            vertical-align: middle;
        }
    }
</style>